import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faLocationDot } from '@fortawesome/free-solid-svg-icons';

const API_KEY = "AIzaSyA0uGDU891UTdOlZgObTn5iVSYUOse-zEc"; // Replace with your actual API key.

const geocodeAddress = async (address) => {
    try {
        const response = await axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${API_KEY}`
        );

        if (response.data.results && response.data.results.length > 0) {
            return response.data.results[0].geometry.location;
        } else {
            console.error('Geocoding failed: No results found for address:', address);
            throw new Error('Geocoding failed: No results found');
        }

    } catch (error) {
        console.error('Geocoding error:', error);
        throw error;
    }
};

const UserSearch = () => {
    const [inputAddress, setInputAddress] = useState('');
    const [loading, setLoading] = useState(false);
    const [shops, setShops] = useState({ boulangeries: [], restaurants: [] });
    const [error, setError] = useState(null);

    const inputRef = useRef(null);
    const navigate = useNavigate();

    const [address, setAddress] = useState('');
    const [sortBy, setSortBy] = useState('Distance');
    const API_URL = process.env.REACT_APP_API_URL;


    useEffect(() => {
        // Load address from local storage on component mount
        const storedAddress = localStorage.getItem('userAddress');
        if (storedAddress) {
            setInputAddress(storedAddress);
            setAddress(storedAddress)
        }

        // Load shop data from local storage
        const storedShops = localStorage.getItem('nearbyShops');
        if (storedShops) {
            try {
                setShops(JSON.parse(storedShops));
            } catch (parseError) {
                console.error("Error parsing stored shops:", parseError);
                // Handle the error (e.g., clear the invalid data from local storage)
                localStorage.removeItem('nearbyShops');
            }
        }
    }, []);

    useEffect(() => {
        let autocomplete;
        if (window.google && window.google.maps && inputRef.current) {
            autocomplete = new window.google.maps.places.Autocomplete(inputRef.current);
            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (place.geometry) {
                    setInputAddress(place.formatted_address);
                    localStorage.setItem('userAddress', place.formatted_address);
                    setAddress(place.formatted_address);
                    setError(null);
                } else {
                    setError("Veuillez sélectionner une adresse valide.");
                }
            });
        }

        return () => {
            if (autocomplete) window.google.maps.event.clearInstanceListeners(autocomplete);
        };
    }, []);

    const fetchNearbyShops = async () => {
        try {
            setLoading(true);
            const location = await geocodeAddress(inputAddress);
            const token = localStorage.getItem('token');

            const response = await axios.get(`${API_URL}/api/nearbyboulangeries`, {
                headers: { Authorization: `Bearer ${token}` },
                params: location,
            });
            console.log("account", response.data)
            const boulangeries = response.data.shops.filter(shop => shop.type === 'boulangerie');
            const restaurants = response.data.shops.filter(shop => shop.type === 'restaurant');
            const newShops = { boulangeries, restaurants };

            setShops(newShops);
            localStorage.setItem('nearbyShops', JSON.stringify(newShops)); // Persist shop data

        } catch (error) {
            setError('La récupération des commerces a échoué. Veuillez réessayer.');
            console.error('Error fetching shops:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!inputAddress) return setError("Veuillez entrer une adresse.");
        setError(null);
        localStorage.setItem('userAddress', inputAddress);
        fetchNearbyShops();
    };

    const handleInputChange = (e) => {
        setInputAddress(e.target.value);
        setAddress(e.target.value);
    };

    const handleSearchChange = (e) => {
        setAddress(e.target.value);
    };

    const handleSortChange = (e) => {
        setSortBy(e.target.value);
    };

    useEffect(() => {
        // Whenever the shops data changes, persist it.  This is a more robust approach.
        if (shops.boulangeries.length > 0 || shops.restaurants.length > 0) {
            localStorage.setItem('nearbyShops', JSON.stringify(shops));
        }
    }, [shops]); // Dependency array includes 'shops'

    const renderShopList = (title, shopList, path) => (
        shopList.length > 0 && (
            <section className="restaurants-section">
                <h2 className="results-title">{title} près de chez vous</h2>
                <div className="container">
                    <div className="grid">
                        {shopList.map((shop) => (
                            <div key={shop.ownerId} className="restaurant-card">
                                <div className="restaurant-card-image-container">
                                    <img className="restaurant-card-image" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/56dbe1a6d6-7a378c5e695c80a29157.png" alt="modern restaurant interior" />
                                    <div className="restaurant-card-overlay"></div>
                                    <div className="restaurant-card-info">
                                        <h3 className="restaurant-card-title">{shop.name}</h3>
                                        <div className="restaurant-card-rating">
                                            <i className="fa-solid fa-star rating-star"></i>
                                            <span>4.8 (200+ avis)</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="restaurant-card-details">
                                    <div className="restaurant-card-details-info">
                                        {/* <span><i className="fa-solid fa-location-dot location-icon"></i>0.8 km</span> */}
                                        <span><i className="fa-regular fa-clock clock-icon"></i>Ouvert jusqu'à 22h</span>
                                    </div>
                                    <button onClick={() => navigate(`/${path}/${shop.ownerId}`)} className="restaurant-card-button">Voir le menu</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        )
    );

    return (
        <div className="main-container">
            <header className="header">
                <div className="container">
                    <div className="header-content">
                        <div className="header-logo">Lememeprix</div>
                        <div className="header-actions">
                            <button className="cart-button">
                                <i className="fa-solid fa-cart-shopping cart-icon"></i>
                                <span className="cart-count">3</span>
                            </button>
                            <button className="user-button">
                                <i className="fa-regular fa-user user-icon"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            <main className="main-content">
                <section className="search-hero">
                    <div className="search-hero-bg">
                        <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/6c17763303-2aeafbb7be0fd7f1c7ab.png" alt="Parisian street" />
                        <div className="search-hero-overlay"></div>
                    </div>

                    <div className="container">
                        <div className="search-content">
                            <h1 className="search-title">Trouvez votre repas parfait</h1>
                            <div className="search-box">
                                <input
                                    type="text"
                                    placeholder="Recherchez des restaurants ou des boulangeries..."
                                    className="search-input"
                                    value={address}
                                    onChange={handleSearchChange}
                                    ref={inputRef}
                                />
                                <button className="search-button" onClick={handleSubmit}>
                                    <i className="fa-solid fa-search search-icon"></i>
                                    Rechercher
                                </button>
                            </div>
                           {/* <div className="search-suggestions">
                                <div className="suggestions-header">
                                    <p className="suggestions-title">Popular Searches</p>
                                    <div className="suggestions-list">
                                        <span className="suggestion-item">Croissants</span>
                                        <span className="suggestion-item">Baguettes</span>
                                        <span className="suggestion-item">French Cuisine</span>
                                    </div>
                                </div>
                            </div>*/}
                        </div>
                    </div>
                </section>
                {loading ? <p>Chargement des lieux à proximité...</p> : (
                    <>
                        {renderShopList("Boulangeries", shops.boulangeries, "boulangerie")}
                        {renderShopList("Restaurants", shops.restaurants, "restaurant")}
                    </>
                )}


            </main>

            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h4 className="footer-title">Liens rapides</h4>
                            <ul className="footer-links">
                                <li><span className="footer-link">À propos de nous</span></li>
                                <li><span className="footer-link">Contact</span></li>
                                <li><span className="footer-link">Politique de confidentialité</span></li>
                            </ul>
                        </div>
                        <div className="footer-section">
                            <h4 className="footer-title">Suivez-nous</h4>
                            <div className="social-icons">
                                <span className="social-icon"><i className="fa-brands fa-facebook"></i></span>
                                <span className="social-icon"><i className="fa-brands fa-instagram"></i></span>
                                <span className="social-icon"><i className="fa-brands fa-twitter"></i></span>
                            </div>
                        </div>
                        <div className="footer-section">
                            <h4 className="footer-title">Assistance</h4>
                            <div className="contact-info">
                                <p>Besoin d'aide ? Contactez-nous :</p>
                                <div className="contact-details">
                                    <i className="fa-solid fa-phone"></i>
                                    <span>+33 1 23 45 67 89</span>
                                </div>
                                <div className="contact-details">
                                    <i className="fa-solid fa-envelope"></i>
                                    <span>support@lememeprix.com</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <style jsx>{`
            .main-container {
        min-height: 100vh;
        background-color: #fff;
    }

    /* Header */
    .header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background-color: #fff;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        z-index: 50;
    }

    .header .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 1rem;
    }

    .header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem;
    }

    .header-logo {
        font-size: 1.5rem;
        font-weight: bold;
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .header-actions button {
        color: #4b5563;
        transition: color 0.2s ease;
        background: none;
        border: none;
        cursor: pointer;
    }

    .header-actions button:hover {
        color: #1f2937;
    }

    .main-content {
        padding-top: 5rem;
    }

    /* Search Hero Section */
    .search-hero {
        position: relative;
        height: 500px;
    }

    .search-hero-bg {
        position: absolute;
        inset: 0;
    }

    .search-hero-bg img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .search-hero-overlay {
        position: absolute;
        inset: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .search-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 0 1rem;
    }

    .search-title {
        font-size: 2.25rem;
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 2rem;
    }

    .search-box {
        width: 100%;
        max-width: 32rem;
        position: relative;
    }

    .search-input {
        width: 100%;
        padding: 1rem 1.5rem;
        border-radius: 9999px;
        font-size: 1.125rem;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        outline: none;
        border: 2px solid #ef4444;
    }

    .search-button {
        position: absolute;
        right: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
        background-color: #ef4444;
        color: #fff;
        padding: 0.5rem 1rem;
        border-radius: 9999px;
        transition: background-color 0.2s ease;
        border: none;
        cursor: pointer;
    }

    .search-button:hover {
        background-color: #dc2626;
    }

    .search-suggestions {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 0.5rem;
        background-color: #fff;
        border-radius: 0.5rem;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        z-index: 10;
    }

    .suggestions-header {
        padding: 1rem;
        border-bottom: 1px solid #e5e7eb;
    }

    .suggestions-title {
        font-size: 0.875rem;
        color: #6b7280;
    }

    .suggestions-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-top: 0.5rem;
    }

    .suggestion-item {
        padding: 0.5rem 1rem;
        border-radius: 9999px;
        background-color: #f3f4f6;
        color: #6b7280;
        transition: background-color 0.2s ease;
        cursor: pointer;
    }

    .suggestion-item:hover {
        background-color: #e5e7eb;
    }

    /* Restaurants Section */
    .restaurants-section {
        padding: 2rem 0;
    }

    .results-title {
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 1.5rem;
    }

    .grid {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 1.5rem;
    }

    @media (min-width: 768px) {
        .grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (min-width: 1024px) {
        .grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    .restaurant-card {
        position: relative;
        border-radius: 0.75rem;
        overflow: hidden;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        transition: all 0.3s ease-in-out;
    }

    .restaurant-card:hover {
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        transform: scale(1.02);
    }

    .restaurant-card-image-container {
        position: relative;
        height: 280px;
    }

    .restaurant-card-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .restaurant-card-overlay {
        position: absolute;
        inset: 0;
        background-image: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
    }

    .restaurant-card-info {
        position: absolute;
        bottom: 0;
        padding: 1rem;
        width: 100%;
    }

    .restaurant-card-title {
        color: #fff;
        font-size: 1.25rem;
        font-weight: bold;
        margin-bottom: 0.25rem;
    }

    .restaurant-card-rating {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        color: #fff;
    }

    .restaurant-card-rating i {
        color: #f59e0b;
    }

    .restaurant-card-details {
        padding: 1rem;
        background-color: #fff;
    }

    .restaurant-card-details-info {
        display: flex;
        justify-content: space-between;
        font-size: 0.875rem;
        color: #6b7280;
    }

    .location-icon,
    .clock-icon {
        margin-right: 0.25rem;
    }

    .restaurant-card-button {
        width: 100%;
        margin-top: 0.75rem;
        padding: 0.5rem 1rem;
        background-color: #f97316;
        color: #fff;
        border-radius: 0.5rem;
        text-align: center;
        transition: background-color 0.2s ease-in-out;
        border: none;
        cursor: pointer;
    }

    .restaurant-card-button:hover {
        background-color: #ea580c;
    }

    /* Floating Cart */
    .floating-cart {
        position: fixed;
        bottom: 1.5rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 40;
    }

    .floating-cart button {
        background-color: #000;
        color: #fff;
        padding: 0.75rem 1.5rem;
        border-radius: 9999px;
        font-weight: 500;
        transition: background-color 0.2s ease;
        border: none;
        cursor: pointer;
    }

    .floating-cart button:hover {
        background-color: #374151;
    }

    .cart-icon {
        margin-right: 0.5rem;
    }

    /* Footer */
    .footer {
        background-color: #f9fafb;
        padding: 3rem 0;
    }

    .footer .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 1rem;
    }

    .footer-content {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 2rem;
    }

    @media (min-width: 768px) {
        .footer-content {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    .footer-section {
        display: flex;
        flex-direction: column;
    }

    .footer-title {
        font-size: 1.25rem;
        font-weight: bold;
        margin-bottom: 1rem;
    }

    .footer-links {
        list-style: none;
        padding: 0;
    }

    .footer-links li {
        margin-bottom: 0.5rem;
    }

    .footer-link {
        color: #4b5563;
        cursor: pointer;
        transition: color 0.2s ease;
    }

    .footer-link:hover {
        color: #6b7280;
    }

    .social-icons {
        display: flex;
        gap: 1rem;
    }

    .social-icons i {
        font-size: 1.5rem;
        color: #4b5563;
        cursor: pointer;
        transition: color 0.2s ease;
    }

    .social-icons i:hover {
        color: #6b7280;
    }

    .contact-info {
        display: flex;
        flex-direction: column;
    }

    .contact-details {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
        color: #4b5563;
    }
          `}</style>
        </div>
    );
};

export default UserSearch;